// enums/MemberEnums.js
// ===========================================
// Shared enumerations for Member and Partner
// ===========================================
export const EXPERIENCE_LEVELS = ["experienced", "curious", "first_time"];
export const MEMBER_STATUSES = [
  "local",
  "avatar",
  "gender",
  "relation",
  "sexual_identity",
  "sexual_role",
  "attraction_genders",
  "connection_types",
  "intimacy_types",
  "sexual_fantasies",
  "body_type",
  "body_attract",
  "sexual_environment",
  "event_attract",
  "alcohol_cannabis",
  "be_matched",
  "join_host",
  "real_image",
  "social",
  "payment",
  "pending",
  "approved",
];
export const SECONDARY_LANGUAGES = ["si", "hi", "ta", "en"];

export const MEMBER_TYPES = ["single", "couple"];

export const MEMBER_ORIGINS = ["real", "test", "bot"];
// 🧍 Gender identity options
export const GENDERS = [
  "man",
  "woman",
  "non_binary",
  "trans_man",
  "trans_woman",
  "genderfluid",
  "self_describe",
  "not_select",
];

// 🎓 Education levels
export const EDUCATION_LEVELS = [
  "testing",
  "high_school",
  "college",
  "bachelors",
  "masters",
  "phd",
];

// 💞 Loyalty or trust standing
export const LOYALTY_LEVELS = [
  "testing",
  "disloyal",
  "ally",
  "trusted",
  "dedicated",
];

// 💰 Financial background (for targeting / internal insights)
export const FINANCIAL_LEVELS = ["testing", "poor", "middle", "good", "rich"];

// ⚙️ Priority level — affects admin review / visibility
export const PRIORITY_LEVELS = ["standard", "low", "high"];

// 🧑‍🤝‍🧑 How this person works with the organization
export const WORK_WITH_US_ROLES = ["client", "helper", "organizer", "partner"];

// 🌍 Country list (used for both members and partners)
export const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Democratic Republic)",
  "Congo (Republic)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];
